import request from '../request'

/**
 * 协同系统-项目执行-专业提资相关接口
 * 从 cosystem-portal 同步过来的入口，本仓暂未启用对应后端，使用前请核对 URL。
 */

export function addMajorTransfer(data) {
    return request({
        url: '/project-service/cosys/major/transfer/add',
        method: 'POST',
        data
    })
}

export function getMajorTransferDetail(id) {
    return request({
        url: `/project-service/cosys/major/transfer/detail/${id}`,
        method: 'GET'
    })
}

export function exportMajorTransfer(id) {
    return request({
        url: `/project-service/cosys/major/transfer/export/${id}`,
        method: 'GET',
        responseType: 'json',
    })
}

export function getMajorTransferList(params) {
    return request({
        url: '/project-service/cosys/major/transfer/list',
        method: 'GET',
        params
    })
}

export function resubmitMajorTransfer(data) {
    return request({
        url: '/project-service/cosys/major/transfer/resubmit',
        method: 'POST',
        data
    })
}

export function updateMajorTransfer(data) {
    return request({
        url: '/project-service/cosys/major/transfer/update',
        method: 'POST',
        data
    })
}

export function getDesignPlanPersonnel(params) {
    return request({
        url: '/project-service/cosys/design/plan/personnel',
        method: 'GET',
        params
    })
}
